import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
  },
  img: {
    width: 'auto',
    height: 30,
    objectFit: 'contain',
  },
  text: {
    fontSize: 20,
    fontWeight: 700,
    color: 'rgba(255, 255, 255, 0.98)',
    letterSpacing: '-0.02em',
    whiteSpace: 'nowrap',
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img
        className={classes.img}
        src="/phoenix-avatar.png"
        alt=""
        aria-hidden
      />
      <span className={classes.text}>Iron Phoenix</span>
    </div>
  );
};

export default LogoFull;
